import { Link, useLocation } from 'react-router-dom'

const titleMap = {
  'how-it-works': 'How It Works',
  pricing: 'Pricing',
  'property-managers': 'Property Managers',
  faq: 'FAQ',
}

function Breadcrumbs({ className = '' }) {
  const location = useLocation()
  const segments = location.pathname.split('/').filter(Boolean)

  // Hide on home
  if (segments.length === 0) return null

  const crumbs = []
  let pathAcc = ''
  for (let i = 0; i < segments.length; i++) {
    pathAcc += '/' + segments[i]
    const isLast = i === segments.length - 1
    const label = titleMap[segments[i]] || decodeURIComponent(segments[i]).replace(/-/g, ' ')
    crumbs.push({ href: pathAcc, label: label.charAt(0).toUpperCase() + label.slice(1), isLast })
  }

  return (
    <nav aria-label="Breadcrumb" className={`w-full ${className}`}>
      <ol className="flex items-center gap-1 text-sm">
        <li>
          <Link to="/" className="text-white/80 hover:text-white">Home</Link>
        </li>
        {crumbs.map((c) => (
          <li key={c.href} className="flex items-center gap-1">
            <span className="text-white/40">/</span>
            {c.isLast ? (
              <span className="text-white" aria-current="page">{c.label}</span>
            ) : (
              <Link to={c.href} className="text-white/80 hover:text-white">{c.label}</Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}

export default Breadcrumbs
